import { IDBPDatabase, openDB } from "idb";

const DB_NAME = "AuthDBGestao";
const STORE_NAME = "tokens";
const TOKEN_KEY = "jwt";

interface TokenData {
  tkn: string;
  empresaID?: string | null;
  usuario: object;
  menu: object;
}

class TokenService {

  dbPromise: Promise<IDBPDatabase>;

  constructor() {
    this.dbPromise = openDB(DB_NAME, 1, {
      upgrade(db) {
        if (db.objectStoreNames.contains("tokens")) {
          db.deleteObjectStore("tokens"); 
        }
        db.createObjectStore("tokens", { keyPath: "id" }); 
      },
    });
  }

  // Salvar Token
  async saveToken(token: TokenData): Promise<void> {
    const db = await this.dbPromise;
    try {
      await await db.put(STORE_NAME, {
        id: TOKEN_KEY,
        value: { ...token },
      });
    } catch (e) {
      tokenService.deleteToken();
    }
  }

  // Buscar Token
  async getToken() {
    const db = await this.dbPromise;
    const tkn = await db.get(STORE_NAME, TOKEN_KEY);    
    return tkn?.value?.tkn;
  }

  // Deletar Token
  async deleteToken() {
    const db = await this.dbPromise;
    await db.delete(STORE_NAME, TOKEN_KEY);
  }

   async getEmpresaID() {
    const db = await this.dbPromise;
    const tkn = await db.get(STORE_NAME, TOKEN_KEY);    
    return tkn?.value?.empresaID;
  }
  
   async getUsuario() {
    const db = await this.dbPromise;
    const tkn = await db.get(STORE_NAME, TOKEN_KEY);    
    return tkn?.value?.usuario;
  }

     async getMenu() {
    const db = await this.dbPromise;
    const tkn = await db.get(STORE_NAME, TOKEN_KEY);    
    return tkn?.value?.menu;
  }
}


const tokenService = new TokenService();
export default tokenService;
